import React from 'react';
function CompanyImage(company, imgWidth="70px"){
	let logoJSX = "";
	if(company.logo){
		logoJSX = <img src={company.logo} alt={company.name}
				style={{width:imgWidth}}/>;
	}
	let finalJSX = "";
	if(company.logoHref){
		finalJSX = <a href={company.logoHref}>{logoJSX}</a>
	}
	else{
		finalJSX = logoJSX;
	}
	return finalJSX;
}

export{CompanyImage};